import { render, staticRenderFns } from "./UserBuyedItems.vue?vue&type=template&id=68004f69&scoped=true&"
import script from "./UserBuyedItems.vue?vue&type=script&lang=js&"
export * from "./UserBuyedItems.vue?vue&type=script&lang=js&"
import style0 from "./UserBuyedItems.vue?vue&type=style&index=0&id=68004f69&lang=scss&scoped=true&"
import style1 from "./UserBuyedItems.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68004f69",
  null
  
)

export default component.exports